import { Component, ViewEncapsulation, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/vortex.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SolarVortexComponent = /** @class */ (function () {
    function SolarVortexComponent() {
    }
    SolarVortexComponent.decorators = [
        { type: Component, args: [{
                    selector: 'solar-vortex',
                    exportAs: 'solar-vortex',
                    encapsulation: ViewEncapsulation.Emulated,
                    template: "<div class=\"vortex-container\">\r\n\t<div class=\"vortex-indicator\">\r\n\t\t<svg id=\"path1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 110 110\"><path _ngcontent-ksq-c19=\"\" fill=\"#AF144B\" d=\"M97.918 74.937l6.665 3.108c-8.738 18.706-27.717 31.67-49.726 31.67-22.01 0-40.988-12.964-49.725-31.67l6.664-3.108c7.567 16.199 24.002 27.425 43.061 27.425 19.06 0 35.494-11.226 43.06-27.425\"></path></svg>\r\n\t\t<svg id=\"path2\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 110 110\"><path _ngcontent-ksq-c19=\"\" fill=\"#FF780F\" d=\"M99.508 71.109l6.911 2.515c2.132-5.855 3.295-12.175 3.295-18.767 0-6.592-1.163-12.912-3.295-18.767l-6.911 2.516c1.846 5.07 2.854 10.543 2.854 16.251 0 5.709-1.008 11.182-2.854 16.252z\"></path></svg>\r\n\t\t<svg id=\"path3\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 110 110\"><path _ngcontent-ksq-c19=\"\" fill=\"#F0325A\" d=\"M7.353 54.857c0-5.708 1.007-11.181 2.853-16.251l-6.91-2.516C1.163 41.945 0 48.265 0 54.857 0 61.45 1.164 67.77 3.295 73.624l6.911-2.515c-1.846-5.07-2.853-10.543-2.853-16.252\"></path></svg>\r\n\t\t<svg id=\"path4\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 110 110\"><path _ngcontent-ksq-c19=\"\" fill=\"#BE0028\" d=\"M54.857 7.353c19.06 0 35.494 11.226 43.06 27.425l6.666-3.108C95.845 12.963 76.866 0 54.857 0 32.847 0 13.87 12.963 5.131 31.67l6.665 3.108c7.567-16.2 24.002-27.425 43.061-27.425\"></path></svg>\r\n\t</div>\r\n</div>",
                    styles: [":host{display:inline-block}.vortex-container{display:inline-block}.vortex-container svg{position:absolute;top:0;right:0;left:0;bottom:0;margin:auto}.vortex-container .vortex-indicator{padding:20px;position:relative}:host[xsmall] .vortex-indicator{padding:10px}:host[small] .vortex-indicator{padding:20px}:host[medium] .vortex-indicator{padding:40px}:host[large] .vortex-indicator{padding:60px}#path1{-webkit-animation-duration:2s;animation-duration:2s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}#path1,#path2{-webkit-animation-name:vortexSpinner;animation-name:vortexSpinner;position:absolute}#path2{-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}#path2,#path3{-webkit-animation-duration:1s;animation-duration:1s}#path3{-webkit-animation-name:vortexSpinner;animation-name:vortexSpinner;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}#path3,#path4{position:absolute}#path4{-webkit-animation-name:vortexVisual;animation-name:vortexVisual;-webkit-animation-duration:2s;animation-duration:2s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}@-webkit-keyframes vortexSpinner{0%{transform:rotate(0)}to{transform:rotate(1turn)}}@keyframes vortexSpinner{0%{transform:rotate(0)}to{transform:rotate(1turn)}}@-webkit-keyframes vortexVisual{0%,50%,75%{display:none;opacity:0}to{display:none;opacity:1}}@keyframes vortexVisual{0%,50%,75%{display:none;opacity:0}to{display:none;opacity:1}}"]
                }] }
    ];
    return SolarVortexComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/vortex.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SolarVortexModule = /** @class */ (function () {
    function SolarVortexModule() {
    }
    SolarVortexModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        SolarVortexComponent
                    ],
                    declarations: [
                        SolarVortexComponent
                    ]
                },] }
    ];
    return SolarVortexModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: solar-vortex.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { SolarVortexComponent, SolarVortexModule };
//# sourceMappingURL=solar-vortex.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@solar/vortex/fesm5/solar-vortex.js
// module id = ./node_modules/@solar/vortex/fesm5/solar-vortex.js
// module chunks = 0